module.exports = __webpack_public_path__ + "static/media/Homepage.7e0db706.svg";